<template>
  <div>
    <v-row>
      <v-col cols="4">
        <employee-profile-payroll-bank-detail-container-view 
          :employee-uid="employeeUid" 
          :is-resigned="isResigned"
        />
      </v-col>
      <v-col cols="4">
        <employee-profile-payroll-epf-detail-container-view 
          :employee-uid="employeeUid" 
          :is-resigned="isResigned"
        />
      </v-col>
      <v-col cols="4">
        <employee-profile-payroll-income-tax-detail-container-view 
          :employee-uid="employeeUid" 
          :is-resigned="isResigned"
        />
      </v-col>
      
      <v-col cols="12">
        <employee-profile-payroll-payroll-company-container-view
          ref="payrollContainer"
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
          @updated="$emit('updated')"
          @loaded="$emit('loaded')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollIncomeTaxDetailContainerView: () => import('@/components/hris/employee/profile/payroll/income-tax-detail/ContainerView'),
      EmployeeProfilePayrollEpfDetailContainerView: () => import('@/components/hris/employee/profile/payroll/epf-detail/ContainerView'),
      EmployeeProfilePayrollBankDetailContainerView: () => import('@/components/hris/employee/profile/payroll/bank-detail/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/ContainerView'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      loadPayrolls () {
        this.$refs.payrollContainer.loadData()
      },  
    },
  }
</script>
